import { Result } from "./Result";

export interface PagedData<T> {
  result: T;
  pageCount: number;
  totalCount: number;
}

export const EMPTY_PAGED_RESULTS: PagedData<Result[]> = {
  pageCount: 0,
  totalCount: 0,
  result: [],
};
